// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nd-3";
export var downloadButton = "_nd-4";
export var fileContainer = "_nd-9 _nd-7";
export var fileContainerBase = "_nd-7";
export var fileContainerFixedHeight = "_nd-8 _nd-7";
export var fileInfo = "_nd-5";
export var fileInfoWidthRestricted = "_nd-6";
export var fileType = "_nd-1";
export var fileTypeName = "_nd-2";
export var image = "_nd-0";
export var link = "_nd-b";
export var overflowEllipsis = "_nd-a";